import React from 'react';
import ReactDOM from 'react-dom';
import $ from "jquery";

import reportWebVitals from './reportWebVitals';
import App from "./App";
ReactDOM.render(
    <React.StrictMode>
        <App/>
    </React.StrictMode>,
    document.getElementById('root')
);
$(document).ready(function () {
    $("#santaclara").click(function () {
        $("#santa-clara").hide();
        $("#search-city").show();
    });
});

$(document).ready(function () {
    $("#searchcity").click(function () {
        $("#santa-clara").show();
        $("#search-city").hide();
    });
});
reportWebVitals();





